import React from "react";

const ValidationError = ({ message, className = "" }) => {
  if (!message) return null;

  return (
    <div className={`mb-6 p-3 bg-red-50 border border-red-200 rounded-lg flex items-center ${className}`}>
      <svg
        className="w-5 h-5 text-red-500 flex-shrink-0"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 
             4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 
             0 00-1 1v4a1 1 0 102 0V6a1 1 
             0 00-1-1z"
          clipRule="evenodd"
        />
      </svg>
      <p className="ml-2 text-red-600 text-sm font-medium">
        {message}
      </p>
    </div>
  );
};

export default ValidationError;